import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { Music2, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      const u = await login(email, password);
      toast.success(`Bienvenue @${u.pseudo} !`);
      const dest = loc.state?.from || (u.role === "beatmaker" ? "/app/feed" : u.role === "admin" ? "/app/admin" : "/app");
      nav(dest, { replace: true });
    } catch (e2) {
      setErr(formatApiError(e2.response?.data?.detail) || e2.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 relative overflow-hidden">
      <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[500px] h-[500px] bg-violet-600/20 rounded-full blur-3xl" />
      <div className="w-full max-w-md relative animate-fade-up">
        <Link to="/" className="flex items-center justify-center gap-2 mb-8">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-violet-600 to-purple-700 flex items-center justify-center glow-violet">
            <Music2 size={22} className="text-white" />
          </div>
          <span className="font-display font-extrabold text-xl">ilove<span className="gradient-text">muzik</span></span>
        </Link>
        <div className="bg-[#0B0716] border border-zinc-800 rounded-3xl p-7">
          <h1 className="text-2xl font-display font-bold mb-1">Connexion</h1>
          <p className="text-sm text-zinc-400 mb-6">Content de te revoir 👋</p>
          {err && <div className="mb-4 text-sm text-red-400 bg-red-500/10 border border-red-500/20 rounded-xl px-3 py-2" data-testid="login-error">{err}</div>}
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-sm font-medium text-zinc-300">Email</label>
              <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="mt-1 w-full bg-zinc-900 border border-zinc-700 rounded-xl px-4 py-3 text-sm focus:border-violet-500 outline-none" placeholder="ton@email.com" />
            </div>
            <div>
              <label className="text-sm font-medium text-zinc-300">Mot de passe</label>
              <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                className="mt-1 w-full bg-zinc-900 border border-zinc-700 rounded-xl px-4 py-3 text-sm focus:border-violet-500 outline-none" placeholder="••••••••" />
            </div>
            <button data-testid="login-submit" disabled={busy} type="submit"
              className="w-full flex items-center justify-center gap-2 py-3 rounded-xl bg-gradient-to-r from-violet-600 to-purple-600 hover:from-violet-500 hover:to-purple-500 font-semibold transition-all disabled:opacity-60">
              {busy && <Loader2 size={16} className="animate-spin" />} Se connecter
            </button>
          </form>
          <p className="text-sm text-zinc-400 text-center mt-6">
            Pas encore de compte ? <Link to="/register" className="text-violet-400 font-medium">S'inscrire</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
